/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { FontSizes } from "@fluentui/react";

/**
 * Default font size used for inputs on desktop
 */
export const desktopInputFontSize = FontSizes.size20;

/**
 * Default input height on desktop
 */
export const desktopInputHeight = 48;

/**
 * Default font size used for inputs on mobile and tablet sizes
 */
export const mobileInputFontSize = FontSizes.size16;

/**
 * Default input height on mobile and tablet sizes
 */
export const mobileInputHeight = 38;
